import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "text-center"
};
const _hoisted_3 = {
    key: 0,
    class: "p-2 pt-1",
    style: { "background-color": "#999999", "color": "white", "font-size": "1.15em" }
};
import { computed } from 'vue';
import { RoomSelector } from '@/components/Rooms';
import useRooms from '@/compositions/useRooms';
export default /*#__PURE__*/ _defineComponent({
    props: {
        group: null,
        allGroups: null,
        teamId: null,
        timeslot: null,
        editMode: { type: Boolean }
    },
    emits: ["update"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const group = computed(() => props.group);
        const { rooms } = useRooms();
        const onUpdate = () => {
            emits('update', props.allGroups);
        };
        const getRoomId = (group, teamId, timeslot) => {
            var _a, _b;
            if (group.start_time === null)
                return null;
            if (group.start_time > timeslot.getTime() / 1000)
                return null;
            if (group.start_time + props.group.teams[props.teamId].duration <= timeslot.getTime() / 1000)
                return null;
            const slotIndex = (timeslot.getTime() / 1000 - group.start_time) / (20 * 60);
            return (_b = (_a = group.teams[teamId]) === null || _a === void 0 ? void 0 : _a.schedule[slotIndex]) !== null && _b !== void 0 ? _b : null;
        };
        const includePause = computed(() => {
            if (group.value.pause_preferences.length === 0) {
                return false;
            }
            return !blackList.value.includes('pause');
        });
        const roomId = computed({
            get: () => {
                return getRoomId(group.value, props.teamId, props.timeslot);
            },
            set: (value) => {
                if (props.group.start_time === null)
                    return;
                if (props.group.start_time > props.timeslot.getTime() / 1000)
                    return;
                if (props.group.start_time + props.group.teams[props.teamId].duration <= props.timeslot.getTime() / 1000)
                    return;
                const slotIndex = (props.timeslot.getTime() / 1000 - props.group.start_time) / (20 * 60);
                props.group.teams[props.teamId].schedule[slotIndex] = value;
            }
        });
        const roomNames = computed(() => {
            const names = { 'pause': 'Pauze' };
            Object.entries(rooms.value).map(([roomId, roomConfig]) => {
                names[roomId] = roomConfig.name;
            });
            return names;
        });
        const blackList = computed(() => {
            const blackListIds = [];
            Object.values(props.allGroups).forEach(group => {
                Object.values(group.teams).forEach(team => {
                    const roomId = getRoomId(group, team.id, props.timeslot);
                    if (roomId !== null)
                        blackListIds.push(roomId);
                });
            });
            Object.values(props.group.teams[props.teamId].schedule).forEach(roomId => {
                if (roomId !== null)
                    blackListIds.push(roomId);
            });
            return blackListIds.filter(id => id !== roomId.value);
        });
        return (_ctx, _cache) => {
            return (__props.editMode)
                ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                    (_unref(roomId))
                        ? (_openBlock(), _createBlock(_unref(RoomSelector), {
                            key: 0,
                            modelValue: _unref(roomId),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(roomId) ? (roomId).value = $event : null)),
                            onUpdate: onUpdate,
                            blackList: _unref(blackList),
                            includePause: _unref(includePause)
                        }, null, 8, ["modelValue", "blackList", "includePause"]))
                        : _createCommentVNode("", true)
                ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_2, [
                    (_unref(roomId))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(roomNames)[_unref(roomId)]), 1))
                        : _createCommentVNode("", true)
                ]));
        };
    }
});
